
eval("define(\'text!orofilter/templates/filters-state-popover.html\',[],function () { return \'<div class=\"popover filters-state-popover\" role=\"tooltip\">\\n    <div class=\"arrow\"></div>\\n    <h3 class=\"popover-title\"></h3>\\n    <div class=\"popover-content popover-no-close-button\"></div>\\n</div>\\n\';});\n\n//# sourceURL=/text!orofilter/templates/filters-state-popover.html");

